<template>
  <div class="chat-window" v-loading="isLoading">
    <div class="chat-header">
      <div v-if="!isChatDesktopView" @click="backToExpertList()"><i class="el-icon-arrow-left right-margin-5 cursor-pointer" style="font-size: 27px; font-weight: 500"></i></div>
      <div class="flex">
        <img :src="serverHostName + selectedUserForChat.second_user_details.photo" alt="User Avatar" class="user-avatar" v-if="selectedUserForChat.second_user_details && selectedUserForChat.second_user_details.photo" />
        <div alt="User Avatar" class="user-initial-avatar" v-else>{{ initialName(selectedUserForChat.second_user_details && selectedUserForChat.second_user_details.full_name ? selectedUserForChat.second_user_details.full_name : 'U') }}</div>

        <div class="user-info" v-if="selectedUserForChat.second_user_details">
          <div class="user-name" @click="goToExpertStore(selectedUserForChat)">
            {{ selectedUserForChat.second_user_details.full_name }}
            <img src="../assets/images/verify.svg" class="verified-tick" alt="" v-if="selectedUserForChat.second_user_details.profession != 'Retail Investor'" />
          </div>
          <div class="sebi-number" style="color: #2488ff; font-weight: 500" v-if="typingEvent.user_id != userProfile.id && typingEvent.is_user_typing">
            <!-- {{ `${selectedUserForChat.second_user_details.full_name} is typing...` }} -->
            typing...
          </div>
          <div class="sebi-number" v-else-if="selectedUserForChat.second_user_details.sebi_regi_number">SEBI No. {{ selectedUserForChat.second_user_details.sebi_regi_number }}</div>
          <!-- <div class="status" v-if="selectedUser.second_user_details.sebi_regi_number">SEBI No. {{ selectedUser.second_user_details.sebi_regi_number }}</div> -->
          <!-- <div class="expert-status">
            <span :class="{'online': expertStatus === 'Online', 'offline': expertStatus === 'Offline','busy': expertStatus === 'Busy'}">
            {{ expertStatus }}
            </span>
          </div> -->
        </div>
      </div>

      <div style="margin-left: auto; font-weight: 500; text-align: right">
        <span v-if="!isSessionExpired && isTimerStarted" :style="[Math.floor(remainingTime / 60) < 1 && remainingTime != 0 ? { color: '#c73e1d' } : { color: '#000' }]">{{ sessionTimerCount }} Min</span>

        <div class="flex-center help-txt">
          <span class="flex-center" @click="openWhatsApp()">
            Help
            <img src="../assets/images/ChatImages/HelpIcon.png" width="17px" alt="" />
          </span>

          <div v-if="!isSessionExpired && isTimerStarted && userProfile.profession == 'Retail Investor'" class="left-margin-5 chat-end-tab" @click="endChat()">End Chat</div>
        </div>
      </div>
    </div>

    <!-- end chat confirm dialog -->
    <el-dialog :visible.sync="endChatConfirmationDialogVisible" class="feedback-popup feedback-two" :show-close="false" style="margin-top: 60px">
      <div class="text-center">
        <div class="popup-title">Are you sure you want to end this chat?</div>

        <div class="chat-btn-container top-margin-10">
          <el-button class="btn-light-blue-borderd right-margin-10" size="small" style="width: 95px" @click="endChatConfirmationDialogVisible = false">No</el-button>

          <el-button class="btn-light-blue-filled" style="width: 95px" @click="handleEndChatConfirmationDialog()" :loading="isChatEnding">Yes</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- Chat Content (scrollable) -->
    <!-- <div ref="scrollableDiv" class="chat-content" @scroll="onScroll"> -->
    <div ref="scrollableDiv" class="chat-content">
      <!-- <div class="sticky-date" v-if="visibleDate">
        {{ formatDate(visibleDate) }}
      </div> -->

      <div class="message" v-for="(message, index) in messages" :key="index" :class="{ 'is-user': message.isUser }">
        <!-- for text message -->
        <!-- <div v-if="message.type == 'TEXT'" class="message-text" >{{ message.message }}</div> -->
        <p v-if="message.type == 'TEXT'" class="message-text" v-html="formateMsg(message.message)"></p>

        <!-- for media type message -->
        <div v-if="message.type == 'MEDIA'" class="message-text">
          <el-image v-if="getFileCategory(message.meta) == 'IMAGE'" class="message-text" style="width: 100px; height: 100px" :src="message.message" fit="contain" :preview-src-list="[message.message]"></el-image>

          <!-- for non image files -->
          <div v-if="getFileCategory(message.meta) != 'IMAGE'">
            <!-- <div width="100%" height="150px">{{ message.meta.fileName  }}</div> -->

            <div v-if="getFileCategory(message.meta) != 'IMAGE'" class="file-thumbnail">
              <img :src="getFileIcon(message.meta.fileExtension)" alt="File Icon" width="50px" height="50px" class="file-icon" />

              <div class="top-margin-5 ellipsis" style="font-size: 12px">{{ message.meta.fileName }}</div>
            </div>

            <!-- <embed :src="message.message" width="100%" height="200px;" type="message.meta ? message.meta.fileExtension : ''" /> -->
            <!-- <a :href="message.message">{{ message.meta.fileName }}</a> -->
          </div>

          <!-- for no preview/invalid files -->
          <!-- <div v-if="getFileCategory(message.meta) == 'INVALID_FILE'">
            <div style="font-size: 13px;">
              <i class="el-icon-picture-outline"></i>
              No Preview Available
            </div>
          </div> -->

          <!-- <img :src="message.message" alt="Image" class="message-text" style="width: 64px; height: 64px; object-fit: contain;" /> -->
        </div>

        <div class="top-margin-5 flex-space-between">
          <i class="el-icon-download cursor-pointer" v-if="message.type == 'MEDIA'" @click="downloadFile(message)"></i>
          <div class="message-time">{{ message.time | timeFormat }}</div>
        </div>

        <!-- <div class="flex">
          <div class="message-time">{{ message.time | timeFormat }}</div>
          
          <div v-if="!message.is_read">
            <div class="message-status top-margin-10 left-margin-10">
              <span class="tick unread"></span>
              <span class="tick unread"></span>
            </div>
          </div>
  
          <div v-if="message.is_read">
            <div class="message-status top-margin-10 left-margin-10">
              <span class="tick read"></span>
              <span class="tick read"></span>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Chat Input -->
    <div class="chat-footer">
      <div v-if="!isSessionExpired" class="flex-center width-100" style="padding: 10px">
        <el-popover placement="top-start" v-model="showEmojiPicker" trigger="click">
          <emoji-picker @emoji-click="addEmoji"></emoji-picker>
          <div slot="reference" class="emoji-wrapper">😀</div>
        </el-popover>

        <!-- upload media icon -->
        <i class="el-icon-paperclip right-margin-10 cursor-pointer" @click="openUploadFilePallet()"></i>

        <input type="file" ref="chatFileUpload" accept="application/msword,application/pdf,image/jpeg,image/png,image/gif,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv" style="display: none" @change="uploadImage" />

        <div class="mention-wrapper" ref="mentionWrapper">
          <input class="post-input message-input" type="textarea" ref="messageInput" v-model="newMessage" @input="onInput" placeholder="Type a message" @keyup.enter="sendMessage" @focus="hideDropdownOnInputFocus" @paste="handlePaste" />
          <el-select ref="selectRef" v-show="showDropdown" v-model="selectedStock" :filterable="true" :remote="true" :remote-method="filterStocks" :loading="stockLoading" placeholder="Search stock" @change="onSelect" class="mention-dropdown" size="mini">
            <el-option v-for="item in stockList" :key="item.id" :label="item.symbol" :value="item" />
          </el-select>
        </div>
        <el-button @click="sendMessage" type="primary" :disabled="!newMessage.trim()">Send</el-button>
      </div>

      <div v-if="isSessionExpired" class="session-expired">
        <div class="font-weight-500 font-style-italic">Chat Ended</div>
        <div class="font-07rem top-margin-5">You cant reply to {{ userProfile.profession == 'Retail Investor' ? 'SEBI Expert' : 'user' }}</div>
      </div>
    </div>

    <el-dialog :visible.sync="connectionErrorDialogVisible" class="feedback-popup feedback-two" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="popup-content network-content">
        <div v-loading="fullscreenLoading" style="font-size: 26px; margin-bottom: 20px"></div>
        <p>Connection Error! Please check your internet connection and try again.</p>
        <div class="refresh-button" @click="reloadTab()">Refresh</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
// import socket from '../mixins/WebSocket.js';
import { screenSize } from '../mixins/ScreenSize.js';
import { ChatTimer } from '../mixins/ChatTimer.js';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { serverHostName, serverAddr, serverAddrForChatToUploadMediaFiles } from '../networkConfig';
import 'emoji-picker-element';
// import AWS from 'aws-sdk';
// import { AWS_CONFIG } from '../mixins/Credentials.js';
import CripNotice from 'crip-vue-notice';

var _ = require('lodash');

export default {
  props: {
    selectedUser: Object,
    loggedInUserType: {
      type: String, // or the expected type of `loggedInUserType`
      required: true,
    },
  },

  mixins: [screenSize, HelperNetworkCallBack, ChatTimer],

  data() {
    return {
      newMessage: '',
      messages: [],
      room: null,
      time: null,
      currentTime: null,
      moment: moment,
      isLoading: false,
      timer: null,
      // remainingTime: 0, // 15 minutes in seconds
      typingEvent: {},
      // isTimerStarted: false,
      clearIsTypingEvent: null,
      sessionTimer: null,
      visibleDate: null, // To track the currently visible date
      showEmojiPicker: false,
      serverHostName: serverHostName,
      endChatConfirmationDialogVisible: false,
      isChatEnding: false,
      s3: null,
      // expertStatus: null
      endChatManually: false,
      selectedStock: null,
      showDropdown: false,
      stockList: [],
      stockLoading: false,
      connectionErrorDialogVisible: false,
      fullscreenLoading: true,
    };
  },

  filters: {
    timeFormat(time) {
      return moment(time).format('MMM D, YYYY, hh:mm a');
    },
  },

  async mounted() {
    document.addEventListener('click', this.handleClickOutside);

    // Remove existing listeners to avoid duplication
    this.$socket.off('room-messages');
    this.$socket.off('room-joined');
    this.$socket.off('is-user-typing');
    this.$socket.off('chat-message');
    this.$socket.off('errorValidation');

    await this.$socket.on('room-messages', (data) => {
      if (data.login_user_id == this.userProfile.id) {
        this.isLoading = true;

        this.startTimer();

        setTimeout(async () => {
          console.log(`Messages for room ${data.room}:`, data);

          this.messages = [];
          // let unReadMessages = [];

          if (data.data && data.data.length) {
            data.data.sort((a, b) => {
              return a.created_at - b.created_at;
            });

            // for (let i = 0; i < data.data.length; i++) {
            //   if(!data.data[i].is_read){
            //     unReadMessages.push(data.data[i].id);
            //   }
            // }

            // console.log("unReadMessages", unReadMessages);

            // let readPromise = this.markMessagesAsRead(unReadMessages, data.data);

            // readPromise.then(() => {
            for (let i = 0; i < data.data.length; i++) {
              this.pushMessages(data.data[i]);
            }
            // })
          }

          this.isLoading = false;
        }, 500);
      }
    });

    this.$socket.on('room-joined', async (data) => {
      if (data.login_user_id == this.userProfile.id) {
        console.log('room-joined', data);
        this.isLoading = true;

        this.endChatManually = false;

        let room = this.roomId;

        this.getRoomMessages(room);

        // this.$nextTick(() => {
        //   console.log(this.userProfile);
        // //  if (this.userProfile && this.userProfile.profession == 'Retail Investor') {
        //   var autoGenerateMessage = 'Auto generated message';
        //   console.log(autoGenerateMessage, 'autoGenerateMessage');

        //   this.$socket.emit('send_room_message', { room: this.roomId, message: autoGenerateMessage, sender_id: this.userProfile.id, is_read: false });
        // //  }
        // });

        // this.$socket.emit('get_room_messages', { room });
      }
    });

    this.$socket.on('is-user-typing', (data) => {
      console.log('user is typing:', data);
      this.typingEvent = data;

      this.$store.commit('commitUserTypingEvent', this.typingEvent);

      setTimeout(() => {
        this.typingEvent = {};
        this.$store.commit('commitUserTypingEvent', this.typingEvent);
      }, 5000);
    });

    this.$socket.on('chat-message', async (data) => {
      console.log('Received message:', data);
      if (data.room == this.roomId) {
        // await this.markMessagesAsRead(data, [data]);
        this.pushMessages(data, 'UPDATE_LAST_MESSAGE');
      } else {
        let messageObj = {
          message: data.message,
          time: data.created_at,
          isUser: data.sender_id == this.userProfile.id ? true : false,
          sender_id: data.sender_id,
          room: data.room,
          type: data.type,
          meta: data.meta,
          // is_read: msgResponse.is_read
        };
        this.$store.commit('commitLastMessage', messageObj);
      }
    });

    this.$socket.on('errorValidation', (data) => {
      console.log('error from ChatWindow:', data);
    });

    this.$socket.on('connect_error', () => {
      console.log('connect_error');

      this.connectionErrorDialogVisible = true;

      // setTimeout(() => {
      //   this.$socket.connect(); // Attempt to reconnect after 5 seconds
      // }, 2000);
    });

    this.$socket.on('connect', () => {
      console.log('connected to socket server again');

      this.connectionErrorDialogVisible = false;

      // if(expert){
      //   this.$socket.emit('update_user_status', { user_id: this.userProfile.id, status:  'Online' });
      // }

      if (this.roomId && this.selectedUser && Object.keys(this.selectedUser).length) {
        this.joinRoom();
      }
    });

    // // Configure AWS SDK
    // AWS.config.update({
    //   accessKeyId: AWS_CONFIG.accessKeyId,
    //   secretAccessKey: AWS_CONFIG.secretAccessKey,
    //   region: AWS_CONFIG.region,
    // });

    // Initialize S3 instance
    // this.s3 = new AWS.S3();
  },

  methods: {
    reloadTab() {
      window.location.reload();
    },
    handleClickOutside(event) {
      const wrapper = this.$refs.mentionWrapper;
      if (wrapper && wrapper.contains && !wrapper.contains(event.target)) {
        this.showDropdown = false;
      }
    },
    hideDropdownOnInputFocus() {
      this.showDropdown = false;
    },
    onInput() {
      const words = this.newMessage.split(/\s/);
      const lastWord = words[words.length - 1];

      if (lastWord.startsWith('@')) {
        this.searchKeyword = lastWord.slice(1);
        this.showDropdown = true;
        this.filterStocks(this.searchKeyword);

        // Wait a bit to let DOM update, then open the dropdown
        this.$nextTick(() => {
          this.$refs.selectRef.focus(); // focus is required
          this.$refs.selectRef.toggleMenu(); // force open
        });
      } else {
        this.showDropdown = false;
      }

      this.setIsUserTyping();
    },

    setIsUserTyping: _.debounce(function () {
      if (this.newMessage.trim().length) {
        console.log('sending user typing event');
        this.$socket.emit('set_is_user_typing', { room: this.roomId, user_id: this.userProfile.id, is_user_typing: true });
      } else {
        console.log('erasing');
        this.$socket.emit('set_is_user_typing', { room: this.roomId, user_id: this.userProfile.id, is_user_typing: false });
      }
    }, 500),

    filterStocks(query) {
      if (!query) {
        this.stockList = [];
        return;
      }
      this.stockLoading = true;

      this.searchStockList(query);
    },

    onSelect(stock) {
      // for multiselect
      //  const exists = this.selected_stock_object.some((item) => item.id === stock.id);
      //  if (!exists) {
      //   this.selected_stock_object.push(stock);
      //  }

      //  const words = this.newMessage.split(/\s/);
      //  words[words.length - 1] = '@' + stock.symbol;
      //  this.newMessage = words.join(' ') + ' ';
      //  this.showDropdown = false;
      //  this.selectedStock = null;

      //  console.log(this.selected_stock_object);

      //  for single select

      // Format the stock symbol
      const newMention = '@' + stock.symbol;

      // Remove all previous @stock mentions from newMessage
      const words = this.newMessage.trim().split(/\s+/);
      const filteredWords = words.filter((word) => !word.startsWith('@'));

      // Add the new selected stock at the end
      this.newMessage = [...filteredWords, newMention].join(' ') + ' ';

      // Update selected_stock_object to only contain the newly selected stock
      this.selected_stock_object = stock;

      // Close dropdown and clear selection
      this.showDropdown = false;
      this.selectedStock = null;
    },

    searchStockList(query) {
      // this.clearAllFields();
      this.stockList = [];
      let cleanQuery = query.replace(/^@/, '');
      cleanQuery = cleanQuery.toLowerCase();
      serverAddr
        .post('/recommendation/v1/read-stock', {
          search: cleanQuery,
          key: 'stock',
        })
        .then((response) => {
          if (response.data.status) {
            this.stockLoading = true;
            this.stockList = response.data.data;
          } else {
            this.stockList = [];
          }
        })
        .catch((error) => {
          this.stockLoading = false;
          console.log('error', error);
        })
        .finally(() => {
          this.stockLoading = false;
        });
    },
    formateMsg(text) {
      if (!text) return '';
      return text.replace(/\n/g, '<br>').replace(/@(\w+)/g, (match, stockSymbol) => {
        return `<span class="external-link-color stock-link" data-symbol="${stockSymbol}">@${stockSymbol}</span>`;
      });
    },

    listenForExpertStatus() {
      this.$socket.on('available-experts', (experts) => {
        if (!experts || !experts.data) {
          console.warn('No experts data received.');
          return;
        }

        if (!this.selectedUser || !this.selectedUser.second_user_details) {
          console.warn('selectedUser or second_user_details is missing.');
          return;
        }

        const expertId = this.selectedUser.second_user_details.id;

        // Find expert by ID
        const selectedExpert = experts.data.find((expert) => expert.id === expertId);

        // if (selectedExpert) {
        //   this.expertStatus = selectedExpert.status; // Update status
        // }
      });
    },

    goToExpertStore(data) {
      let user = data.second_user_details;

      if (user.profession != 'Retail Investor') {
        // on selecting expert commited blank obj in store to cleare existing expert details
        this.$store.commit('commitExpertDetails', {});
        this.$router.push({
          path: '/expert-store',
          query: {
            user_id: user.id,
            user: 'individual',
            name: user.full_name,
          },
        });
      }
    },

    openWhatsApp() {
      var whatsappURL;
      if (window.innerWidth < 992) {
        // Construct the WhatsApp URL
        whatsappURL = `https://wa.me/9321765323`;
      } else {
        whatsappURL = `https://web.whatsapp.com/send?phone=9321765323`;
      }

      // Open the WhatsApp URL
      var newWindow = window.open(whatsappURL, '_blank');

      // Check if a new tab was opened
      if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
        // If the window was blocked or closed, prompt the user to check their browser settings
        alert('WhatsApp window was blocked or closed. Please check your browser settings to allow pop-ups or manage tabs.');
      }
    },

    endChat() {
      this.endChatConfirmationDialogVisible = true;
    },

    handleEndChatConfirmationDialog() {
      this.isChatEnding = true;

      setTimeout(() => {
        let room = this.roomId;
        this.$socket.emit('mark_session_expired', { room, is_force_done: true });

        localStorage.removeItem('isSessionOngoing');

        localStorage.setItem('selectedUserForChat', {});

        this.isChatEnding = false;
        this.endChatManually = true;
        this.endChatConfirmationDialogVisible = false;

        // Get plan details to update chat count
        this.getPlanDetails();

        if (this.userProfile.profession == 'Retail Investor') {
          this.$emit('isFeedbackPopupVisible', true); // Emit feedback popup visibility
        }
      }, 1000);
    },

    getPlanDetails() {
      serverAddr
        .post('/stockants_pro/get-user-subscription/', {})
        .then((response) => {
          if (response.data.status) {
            let stockAntsChatPlan = response.data.data.find((plan) => plan.plan === 'StockAnts Chat');

            stockAntsChatPlan = stockAntsChatPlan ? stockAntsChatPlan : {};

            // Save chat plan details
            this.$store.commit('commitChatPlanDetails', stockAntsChatPlan);
            this.saveSubscribedChatPlanDetails(stockAntsChatPlan);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    sendMessage() {
      if (this.newMessage.trim().length) {
        this.$socket.emit('send_room_message', { room: this.roomId, message: this.newMessage, sender_id: this.userProfile.id, is_read: false, type: 'TEXT' });
        this.newMessage = '';
        // return new Promise((resolve, reject) => {
        //   this.$socket.emit('send_room_message', { room: "1", message: this.newMessage, sender_id: this.userProfile.id }, (response) => {
        //     if (response && response.status === 'sent') {
        //       console.log('Message sent successfully:', response.message);
        //       this.newMessage= "";
        //       this.pushMessages(response);
        //       resolve(response);
        //     } else {
        //       reject(new Error('Failed to send message'));
        //     }
        //   });
        // });

        // Clear message
        this.newMessage = '';

        // Refocus input after a slight delay
        this.$nextTick(() => {
          this.$refs.messageInput.focus();
        });
      }
    },

    // markMessagesAsRead(unReadMessages, data) {
    //   return new Promise((resolve, reject) => {
    //     this.$socket.emit('set_messages_mark_as_read', { ids: unReadMessages }, (ack) => {
    //       console.log('Acknowledgment:', ack);
    //       for (let i = 0; i < data.length; i++) {
    //         this.$set(data[i], 'is_read', true);
    //       }

    //       resolve(data); // Resolve the promise with acknowledgment data
    //     });
    //   });
    // },

    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },

    addEmoji(event) {
      const emoji = event.detail.unicode;
      this.newMessage += emoji; // Append the emoji to the message
      // this.showEmojiPicker = false;
    },

    async getRoomMessages(room) {
      this.showEmojiPicker = false;
      console.log('getting room messages');
      await this.$socket.emit('get_room_messages', { room });

      if (!this.isSessionExpired) {
        // Refocus input after a slight delay
        // focus input on page load so that page would not scroll unnecessarily
        this.$refs.messageInput.readOnly = true;

        this.$refs.messageInput.focus();

        setTimeout(() => {
          this.$refs.messageInput.readOnly = false;
        }, 300);
      }
    },

    backToExpertList() {
      this.$emit('backToExpertList');
    },

    joinRoom(chatRoom, chatStatus) {
      this.messages = [];
      this.isTimerStarted = false; //to toggle display
      this.typingEvent = {};
      this.remainingTime = 0;

      console.log('joining room from side bar');

      this.$socket.emit('join_room', { room: this.roomId, user_id: this.userProfile.id });
    },

    pushMessages(msgResponse, toUpdateLastMessage) {
      this.typingEvent = {}; //clear typing object before pushing message

      let messageObj = {
        message: msgResponse.message,
        time: msgResponse.created_at,
        isUser: msgResponse.sender_id == this.userProfile.id ? true : false,
        sender_id: msgResponse.sender_id,
        room: msgResponse.room,
        type: msgResponse.type,
        meta: msgResponse.meta,
        // is_read: msgResponse.is_read
      };

      this.messages.push(messageObj);

      setTimeout(() => {
        this.$nextTick(() => {
          const scrollableDiv = this.$refs.scrollableDiv;
          if (scrollableDiv) {
            scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
          } else {
            console.warn('scrollableDiv is not defined');
          }
        });
      }, 0);

      if (toUpdateLastMessage) this.$store.commit('commitLastMessage', messageObj);
    },

   formatDate(date) {
      const today = new Date();
      const messageDate = new Date(date);

      if (messageDate.toDateString() === today.toDateString()) {
        return 'Today';
      }

      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      if (messageDate.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
      }

      return messageDate.toLocaleDateString();
    },

    onScroll: _.debounce(function () {
      // setTimeout(() =>{
      const scrollableDiv = this.$refs.scrollableDiv;
      // console.log("scrollableDiv", scrollableDiv)
      // const messages = this.messages;
      const messages = scrollableDiv.querySelectorAll('.message');

      for (let i = 0; i < messages.length; i++) {
        const message = messages[i];
        const rect = message.getBoundingClientRect();

        // // Check if the message is at the top of the visible area
        if (rect.top >= 0 && rect.top <= scrollableDiv.offsetHeight) {
          const date = message.querySelector('.message-time').textContent;
          if (date !== this.visibleDate) {
            this.visibleDate = date;
          }
          break;
        }
      }
      // }, 100);
    }, 500),

    openUploadFilePallet() {
      this.$refs.chatFileUpload.click();
    },

    async handlePaste(event) {
      const clipboardItems = event.clipboardData.items;

      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i];

        // Check if the item is an image
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();
          if (file) {
            // Use the common function to process the file
            this.processFile(file, true);
          }
        }
      }
    },

    async uploadImage(event) {
      try {
        this.isLoading = true; // Show loader

        const file = event.target.files[0];
        event.target.value = null;

        console.log(file);

        if (!file) throw new Error('No file selected');

        // Use the common function to process the file
        this.processFile(file);
      } catch (err) {
        console.error(err);
        this.isLoading = false;

        new CripNotice({
          title: 'Oops! Something went wrong!',
          description: 'Error in uploading image',
          type: 'error',
          duration: 3,
        });
      } finally {
        this.isLoading = false; // Hide loader
      }
    },

    async processFile(file, isPasted = false) {
      try {
        if (file.size > 5 * 1024 * 1024) {
          // 10 MB limit
          new CripNotice({
            title: 'File size exceeded',
            description: 'File size exceeds the 5 MB limit.',
            type: 'error',
            duration: 3,
          });
          this.isLoading = false;
          return;
        }
        const fileName = file.name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        const fileType = file.type;

        console.log(fileExtension);

        const obj = {
          room: this.roomId,
          sender_id: this.userProfile.id,
          is_read: false,
          type: 'MEDIA',
          meta: {
            fileName: fileName,
            fileExtension: fileExtension,
            mimeType: fileType,
          },
          message: file,
        };

        // Use the existing method to upload the image
        this.storeImageToServer(obj);
      } catch (err) {
        console.error(err);
        this.isLoading = false;

        new CripNotice({
          title: 'Oops! Something went wrong!',
          description: 'Error processing file',
          type: 'error',
          duration: 3,
        });
      }
    },

    storeImageToServer(obj) {
      console.log(obj);

      let formData = new FormData();
      formData.append('room', obj.room);
      formData.append('sender_id', obj.sender_id);
      formData.append('is_read', obj.is_read);
      formData.append('type', obj.type);
      formData.append('meta', JSON.stringify(obj.meta)); // Send meta as JSON
      formData.append('message', obj.message); // Attach the file

      console.log('Uploading file:', formData);

      serverAddrForChatToUploadMediaFiles
        .post('/v1/chat/doc_upload', formData)
        .then((response) => {
          if (response.data.status) {
            console.log(response.data.data.message);

            var imgUrl = response.data.data.message;

            this.$socket.emit('send_room_message', {
              room: this.roomId,
              message: imgUrl,
              sender_id: this.userProfile.id,
              is_read: false,
              type: 'MEDIA',
              meta: obj.meta,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          new CripNotice({
            title: 'Oops! Something went wrong!',
            description: 'Please try again...',
            type: 'error',
            duration: 3,
          });
        });
    },

    // function to return file type
    getFileCategory(fileObj) {
      if (!fileObj) return 'txt';

      const fileType = fileObj.fileExtension;

      const allowedMimeTypes = {
        'application/msword': 'DOC',
        'application/pdf': 'PDF',
        file: 'FILE',
        pdf: 'PDF',
        jpeg: 'IMAGE',
        jpg: 'IMAGE',
        png: 'IMAGE',
        gif: 'IMAGE',
        'application/vnd.ms-excel': 'EXCEL',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'EXCEL',
        'text/csv': 'CSV',
        csv: 'CSV',
        XLS: 'XLS',
        XLSX: 'XLSX',
      };

      // Check if the MIME type is allowed and return the corresponding category
      return allowedMimeTypes[fileType] || 'txt';
    },

    downloadFile(obj) {
      console.log('Downloading file:', obj);
      const fileUrl = obj.message;
      const fileName = obj.meta.fileName || 'media_file';

      // Fetch the file as a Blob
      fetch(fileUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch file');
          }
          return response.blob(); // Convert the response to a Blob
        })
        .then((blob) => {
          // Create a temporary URL for the Blob
          const fileUrl = URL.createObjectURL(blob);

          // Create a temporary <a> element
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;

          // Trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl); // Release the Blob URL
        })
        .catch((error) => {
          console.error('Error downloading file:', error);
        });
    },

    getFileIcon(extension) {
      // Return an appropriate icon for the file type
      const icons = {
        pdf: require('../assets/images/ChatImages/pdf.png'),
        doc: require('../assets/images/ChatImages/word.png'),
        docx: require('../assets/images/ChatImages/word.png'),
        xls: require('../assets/images/ChatImages/xls.png'),
        xlsx: require('../assets/images/ChatImages/xls.png'),
        csv: require('../assets/images/ChatImages/csv.png'),
        // zip: require("../assets/images/ChatImages/zip-icon.png"),
        txt: require('../assets/images/ChatImages/document.png'),
      };

      return icons[extension] || icons['txt'];
    },
  },

  computed: {
    roomId() {
      return this.$store.state.room_id;
    },

    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    getUserChatSession() {
      return this.$store.state.sessionDetails;
    },

    selectedUserForChat() {
      return this.$store.state.selectedUserForChat;
    },
  },

  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.clearIsTypingEvent);
    document.removeEventListener('click', this.handleClickOutside);
    // this.$socket.off();
  },
};
</script>

<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.chat-window {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  width: calc(100% - 450px);
  /* Width minus sidebar */
  overflow: hidden;

  .message-input {
    margin-right: 10px;
    margin-right: 10px;
    width: calc(100% - 30px);
    padding: 9px;
    border: 1px solid #ebeef5;
    font-size: 16px;
  }

  .help-txt {
    font-size: 14px;
    font-weight: 500;
    color: #828282;
    cursor: pointer;
    justify-content: right;

    img {
      margin-left: 3px;
    }
  }
  .chat-end-tab {
    font-size: 12px;
    cursor: pointer;
    border: 1px solid;
    padding: 3px 5px;
    border-radius: 5px;
    background-color: #fff5f5;
    color: #ea2526;

    // padding: 15px;
    // border: none;
    // border-radius: 10px;
    // cursor: pointer;
    // -webkit-transition: background-color 0.3s ease;
    // transition: background-color 0.3s ease;
    // color: #9b9b9b;
    // font-weight: 600;
    // font-size: 14px;
    // border: 1px solid transparent;
    // width: 160px;
  }

  .chat-header {
    position: sticky;
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: #fff;
    border-bottom: 1px solid #ddd;

    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }

    .user-initial-avatar {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background-color: #4caf50;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;
    }

    .user-info {
      margin-left: 10px;
    }
    .verified-tick {
      width: 18px;
      position: relative;
      top: 2px;
    }

    .user-name {
      font-weight: bold;
    }
    .sebi-number {
      font-size: 12px;
      font-weight: 500;
      color: #a6a6a6;
    }
    .expert-status {
      font-size: 14px;
      font-weight: 600;
      gap: 8px;

      span {
        font-weight: 600;
        text-transform: capitalize;

        &.online {
          color: #0ba042;
        }

        &.offline {
          color: #ea2526;
        }

        &.busy {
          color: #ff8c00;
        }
      }
    }
  }

  .chat-content {
    display: flex;
    flex-direction: column;
    position: relative;
    flex-grow: 1;
    padding: 10px;
    background-color: #eaeaea;

    background-image: url('../assets/images/ChatImages/chatWindowBackground.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    overflow-y: auto;
  }

  .message {
    display: inline-block;
    /* Makes the element shrink-wrap its content */
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    font-size: 15px;
    background-color: #fff;
    width: fit-content;

    &.is-user {
      margin-left: auto;
      background-color: #d1f7c4;
    }
  }

  .message-time {
    text-align: right;
    // margin-top: 10px;
    font-size: 10px;
  }

  .chat-footer {
    display: flex;
    // padding: 10px;
    background-color: #fff;
    border-top: 1px solid #ddd;
    align-items: center;
    flex-shrink: 0;
  }

  .session-expired {
    background-color: #ddd;
    padding: 10px;
    text-align: center;
    width: 100%;
  }

  .chat-container {
    position: relative;
  }

  .sticky-date {
    position: absolute;
    top: 0;
    background: #eaeaea;
    padding: 5px 10px;
    font-size: 10px;
    text-align: center;
    z-index: 10;
    margin: 0 auto;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;

    .chat-window {
      flex-direction: column;
    }
  }
}

@media screen and (max-width: 1281px) {
  .chat-window {
    height: calc(100vh - 125px);
  }
  .ellipsis {
    max-width: 100px !important;
  }
}

@media screen and (max-width: 880px) {
  .chat-window {
    width: 100%;
    border-top: 1px solid gray;
    height: 100vh;
    position: relative;
    // top: -60px;

    .message {
      max-width: 85%;
      font-size: 12px;
    }

    .message-time {
      font-size: 9px;
    }

    .chat-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2;
    }

    .chat-content {
      padding: 60px 10px 80px;
    }

    .chat-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}

@media screen and (max-width: 500px) {
  .chat-window {
    .chat-header {
      padding: 6px 10px;

      .user-name {
        font-size: 13px;
      }

      .user-avatar {
        width: 32px;
        height: 32px;
      }
    }
    .help-txt {
      font-size: 12px;
    }
    .chat-end-tab {
      font-size: 8px;
      width: 40px;
    }
  }
}
</style>

<style lang="scss">
.chat-window {
  .feedback-popup {
    .el-dialog__body {
      padding: 30px 20px !important;
    }
  }
}
.emoji-wrapper {
  background-color: #eee;
  padding: 5px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 50px;
}

emoji-picker {
  // position: absolute;
  // bottom: 125px;
  // z-index: 1;
  // // width: 300px;
  // height: 350px;
}

.el-image-viewer__mask {
  background: #fff !important;
}

@media screen and (max-width: 500px) {
  .chat-window {
    .el-input__inner {
      height: 33px;
      line-height: 33px;
      font-size: 12px;
    }

    .el-button--primary {
      padding: 8px 20px;
    }
  }
}
</style>

<style scoped>
.mention-wrapper {
  position: relative;
  width: 100%;
}

.mention-dropdown {
  position: absolute;
  top: 0px; /* Adjust based on your input height */
  left: 10px;
  width: 200px;
  z-index: 1000;
}
</style>